var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { faEllipsisH } from '@fortawesome/pro-regular-svg-icons/faEllipsisH';
import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons/faCheckCircle';
import { faArrowAltFromBottom } from '@fortawesome/pro-regular-svg-icons/faArrowAltFromBottom';
import { faSpinner } from '@fortawesome/pro-duotone-svg-icons/faSpinner';
import { Button } from '@appspotr/ui-kit';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useNavigate } from 'react-router-dom';
import { TemplateModal } from '@project/components/TemplateModal';
import { CategoryModal } from '@project/components/CategoryModal';
import { CategoryCreationModal } from '@project/components/CategoryCreationModal';
import { PermissionsWrapper } from '@project/components/PermissionsWrapper';
import GridViewWidget from '@project/components/story-book-components/GridViewWidget';
import { ClickableIcon, ContentPadding, H3 } from '@project/components/base';
import Table from '@project/components/Table/Table';
import { P } from '@project/components/UI-helpers/typography';
import ButtonLink from '@project/components/ButtonLink';
import { colors } from '@project/components/UI-helpers/colors';
import { makeSelectApps, makeSelectRoot, makeSelectCategories, makeSelectAppsMeta, makeSelectLoadingApps, makeSelectPaginationIndex, makeSelectPlatformVersion, makeSelectOrganizationsWithWritePerm, makeSelectTemplate, makeSelectTemplateLoading, selectOrganizationId, } from '@project/containers/Root/selectors';
import * as actions from '@project/containers/Root/actions';
import storageService from '@project/utils/storageService';
import { createSearchFunction, truncate } from '@project/utils';
import { isMajorMinorEqual } from '@project/utils/version';
import { AppGridContainer, FlexBox, SuccessContainer, SuccessTextContainer, } from './styles';
import toast from '../Toast';
import { useDispatch, useSelector } from 'react-redux';
import * as templateActions from '../../store/template/actions';
import { openCreateAppFlow, openQuotaNotAvailablePopover, } from '@project/store/createAppFlow/actions';
import { selectConsumptionSummery } from '../../store/orgStatusSummery/selectors';
import UpdateAppModal from 'containers/AppSettings/UpdateAppModal';
import { appUpdateVersion } from 'store/appSettings/actions';
var statusIcon = function (checked) {
    return checked ? (_jsx(FontAwesomeIcon, { style: { margin: 10 }, color: "rgba(0, 0, 0, 0.85)", size: "1x", icon: faCheck })) : (_jsx(FontAwesomeIcon, { style: { margin: 10 }, color: "rgba(0, 0, 0, 0.65)", size: "1x", icon: faEllipsisH }));
};
var searchFn = createSearchFunction(['name', 'org_name', 'created_at']);
var AppList = function (props) {
    var _a, _b, _c, _d, _e;
    var emptyApp = {
        appstore: false,
        created_at: '',
        folder: '',
        icon: '',
        id: '',
        name: '',
        owner: '',
        patchwork: '',
        playstore: false,
        published: false,
        pwa: false,
        style: null,
        template: false,
        template_with_data: false,
        updated_at: '',
        platform_version: { major: 0, minor: 0, patch: 0 },
        org_id: '',
    };
    var Columns = __spreadArray(__spreadArray([
        {
            Header: 'App Name',
            accessor: 'appName',
            textAlign: 'start',
        }
    ], (props.orgId === 'shared'
        ? [
            {
                Header: 'Organization',
                accessor: 'orgName',
                textAlign: 'start',
            },
        ]
        : []), true), [
        {
            Header: 'Play Store',
            accessor: 'playStore',
        },
        {
            Header: 'App Store',
            accessor: 'appStore',
        },
        {
            Header: 'PWA Web',
            accessor: 'pwaWeb',
        },
        {
            Header: 'Date Created',
            accessor: 'dateCreated',
            Cell: function (row) { return _jsx("div", __assign({ style: { textAlign: 'center' } }, { children: row.value })); },
        },
        {
            Header: 'App Update',
            accessor: 'hasUpdate',
            textAlign: 'center',
        },
        {
            Header: 'App Version',
            accessor: 'appVersion',
            Cell: function (row) { return _jsx("div", __assign({ style: { textAlign: 'center' } }, { children: row.value })); },
        },
        {
            Header: 'Action',
            accessor: 'action',
            filter: 'fuzzyText',
            textAlign: 'end',
            disableSortBy: true,
        },
    ], false);
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _f = useState(false), openTemplate = _f[0], setTemplateModalOpen = _f[1];
    var _g = useState(false), openCategory = _g[0], setOpenCategory = _g[1];
    var _h = useState(false), openNewCategory = _h[0], setOpenNewCategory = _h[1];
    var consumptionSummery = useSelector(selectConsumptionSummery);
    var apps = (_a = consumptionSummery === null || consumptionSummery === void 0 ? void 0 : consumptionSummery.available) === null || _a === void 0 ? void 0 : _a.apps;
    var _j = useState({}), appData = _j[0], setAppData = _j[1];
    var _k = useState(false), updateModalOpen = _k[0], setUpdateModalOpen = _k[1];
    var _l = useState({}), categoryData = _l[0], setCategoryData = _l[1];
    var getTemplateData = props.getTemplateData, template = props.template, organizationsWithWritePerm = props.organizationsWithWritePerm, loadOrganizationsWithWritePerm = props.loadOrganizationsWithWritePerm, resetTemplate = props.resetTemplate, clearMedia = props.clearMedia;
    useEffect(function () {
        openTemplate &&
            (organizationsWithWritePerm === null || organizationsWithWritePerm === void 0 ? void 0 : organizationsWithWritePerm.length) === 0 &&
            loadOrganizationsWithWritePerm();
    }, [
        openTemplate,
        loadOrganizationsWithWritePerm,
        organizationsWithWritePerm === null || organizationsWithWritePerm === void 0 ? void 0 : organizationsWithWritePerm.length,
    ]);
    var orgs = (_b = props.organizationsWithWritePerm) === null || _b === void 0 ? void 0 : _b.map(function (org) { return ({
        value: org.id,
        label: org.name,
    }); });
    var handleTemplateCreation = function (t) {
        var struturedObject = {
            template_organizations: t.organizations,
            template_categories: t.categories,
            app_template: __assign(__assign({}, t.app_template), { app: appData.id, owner: appData.owner }),
        };
        if (t === null || t === void 0 ? void 0 : t.id) {
            props.updateAppTemplate(struturedObject, t === null || t === void 0 ? void 0 : t.id);
        }
        else {
            props.createAppTemplate(struturedObject);
        }
        if (!props.templateLoading)
            setTemplateModalOpen(false);
    };
    var handleOpenAppCreate = function () {
        dispatch(openCreateAppFlow());
    };
    var handleOpenQuotaPopover = function (open) {
        dispatch(openQuotaNotAvailablePopover(open));
    };
    if (((_c = props.apps) === null || _c === void 0 ? void 0 : _c.length) === 0 && !props.loadingTemplate) {
        return (_jsxs(FlexBox, __assign({ flexed: true, centered: true, col: true }, { children: [props.orgId ? (_jsx(P, __assign({ center: true }, { children: "No Apps Available" }))) : (_jsx(ContentPadding, __assign({ fullCenter: true }, { children: _jsxs(SuccessContainer, { children: [_jsx(SuccessTextContainer, { children: _jsx(H3, { children: "Loading apps..." }) }), _jsx(FontAwesomeIcon, { color: "grey", size: "2x", icon: faSpinner, spin: true, style: { margin: 15 } })] }) }))), !props.orgId ||
                    (props.orgId !== 'shared' && (_jsx(PermissionsWrapper, __assign({ action: "create", multiTargets: [
                            'partner:123:organizations',
                            "org:".concat(props.orgId, ":apps"),
                        ] }, { children: _jsx(Button, __assign({ onClick: function () {
                                apps === 0
                                    ? handleOpenQuotaPopover(true)
                                    : handleOpenAppCreate();
                            } }, { children: "Create an App" })) }))))] })));
    }
    var getRows = function () {
        var listApps = searchFn(props.searchValue, props.apps);
        if (listApps.length <= 0)
            return [];
        return listApps.map(function (value) {
            var _a, _b, _c;
            return ({
                id: value.id,
                appName: value.name,
                platform_version_minor: value.platform_version.minor,
                orgName: (_jsx(PermissionsWrapper, __assign({ target: "org:".concat(value.org_id), action: "read", AlternateChildren: function () {
                        return _jsx(_Fragment, { children: truncate(value.org_name, 15) || '' });
                    } }, { children: _jsx(ButtonLink, __assign({ onClick: function () {
                            dispatch(actions.goToOrg(value.org_id, navigate));
                        }, size: "normal", title: "Button", type: "primary" }, { children: truncate(value.org_name, 15) || '' })) }))),
                playStore: statusIcon(value.playstore),
                appStore: statusIcon(value.appstore),
                pwaWeb: statusIcon(value.pwa),
                dateCreated: value.created_at.substring(0, value.created_at.indexOf('T')),
                hasUpdate: !isMajorMinorEqual(props.platformVersion, value.platform_version) ? (_jsx(FlexBox, __assign({ contentCenter: true }, { children: _jsx(Button, __assign({ iconLeft: faArrowAltFromBottom, onClick: function (e) {
                            var _a;
                            e.stopPropagation();
                            setAppData(value);
                            var latestMinorVersion = props.platformVersion.minor;
                            var appMinorVersion = ((_a = value.platform_version) === null || _a === void 0 ? void 0 : _a.minor) || 0;
                            if (latestMinorVersion - appMinorVersion > 2) {
                                setUpdateModalOpen(true);
                                return;
                            }
                            navigate("/organizations/".concat(value.org_id || 'shared', "/apps/").concat(value.id, "/settings"));
                        }, type: "primary" }, { children: "Update" })) }))) : (_jsx(FlexBox, __assign({ contentCenter: true }, { children: _jsx(FontAwesomeIcon, { style: { margin: 10 }, color: "rgba(0, 0, 0, 0.65)", size: "lg", icon: faCheckCircle }) }))),
                appVersion: "".concat(((_a = value.platform_version) === null || _a === void 0 ? void 0 : _a.major) || 0, ".").concat(((_b = value.platform_version) === null || _b === void 0 ? void 0 : _b.minor) || 0, ".").concat(((_c = value.platform_version) === null || _c === void 0 ? void 0 : _c.patch) || 0),
                action: (_jsx(FlexBox, __assign({ contentEnd: true }, { children: _jsx(PermissionsWrapper, __assign({ target: "org:".concat(value.org_id, ":apps"), action: "create", insideTable: true }, { children: value.template !== null ? (_jsx(_Fragment, { children: value.template_global ? (_jsx(PermissionsWrapper, __assign({ action: "create", multiTargets: [
                                    "org:".concat(value.org_id, ":orgadmin"),
                                    'partner:123:organizations',
                                ] }, { children: _jsxs(Button, __assign({ onClick: function (e) {
                                        var _a;
                                        e.stopPropagation();
                                        goToMakeTemplate(value.org_id, value.id, (_a = value.platform_version) === null || _a === void 0 ? void 0 : _a.minor);
                                    }, type: "secondary" }, { children: ["Global template", _jsx(ClickableIcon, { iconClassName: "fas fa-cog", color: colors.primary })] })) }))) : (_jsx(PermissionsWrapper, __assign({ action: "create", multiTargets: [
                                    "org:".concat(value.org_id, ":orgadmin"),
                                    'partner:123:organizations',
                                ], insideTable: true }, { children: _jsxs(Button, __assign({ onClick: function (e) {
                                        var _a;
                                        e.stopPropagation();
                                        goToMakeTemplate(value.org_id, value.id, (_a = value.platform_version) === null || _a === void 0 ? void 0 : _a.minor);
                                    }, type: "secondary" }, { children: ["Template Settings", _jsx(ClickableIcon, { iconClassName: "fas fa-cog", color: colors.primary })] })) }))) })) : (_jsx(Button, __assign({ onClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            e.stopPropagation();
                                            setAppData(value);
                                            return [4 /*yield*/, clearMedia(value.id)];
                                        case 1:
                                            _b.sent();
                                            props.selectOrganization(value.org_id, props.root.me.id);
                                            props.getCategories(value.org_id);
                                            return [4 /*yield*/, getTemplateData('')];
                                        case 2:
                                            _b.sent();
                                            return [4 /*yield*/, goToMakeTemplate(value.org_id, value.id, (_a = value.platform_version) === null || _a === void 0 ? void 0 : _a.minor)];
                                        case 3:
                                            _b.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, type: "outline" }, { children: "Template Settings" }))) })) }))),
            });
        });
    };
    var handleClose = function () {
        setAppData(emptyApp);
        setTemplateModalOpen(false);
    };
    var handleCategoryModalClose = function () {
        setOpenCategory(false);
    };
    var handleNewCategoryModalClose = function () {
        setOpenNewCategory(false);
    };
    var handleNewCategoryModalGoBack = function () {
        setOpenNewCategory(false);
        setOpenCategory(true);
    };
    var handleCategoryModalGoBack = function () {
        setTemplateModalOpen(true);
        setOpenCategory(false);
    };
    var handleCategoryCreation = function (categoryObject) {
        var _a;
        if (categoryData && ((_a = Object.keys(categoryData)) === null || _a === void 0 ? void 0 : _a.length)) {
            props.updateCategory(props.root.selectedOrganizationId, categoryObject);
        }
        else {
            props.createCategory(props.root.selectedOrganizationId, categoryObject);
        }
        setOpenNewCategory(false);
        setOpenCategory(true);
    };
    var handleCategoryDeletion = function (categoryId) {
        props.deleteCategory(props.root.selectedOrganizationId, categoryId);
    };
    var handleOpenCategoryModal = function () {
        setTemplateModalOpen(false);
        setOpenCategory(true);
    };
    var openEditModal = function (data) {
        setCategoryData(data);
        setOpenNewCategory(true);
        setOpenCategory(false);
    };
    var onRowClick = function (row) {
        var _a;
        var latestMinorVersion = props.platformVersion.minor;
        var appMinorVersion = row.platform_version_minor;
        if (latestMinorVersion - appMinorVersion > 2) {
            setUpdateModalOpen(true);
            setAppData(row);
        }
        else {
            var orgId = (_a = row.orgName.props.target) === null || _a === void 0 ? void 0 : _a.split(':')[1];
            navigate("/organizations/".concat(orgId || 'shared', "/apps/").concat(row.id, "/overview"));
        }
    };
    var goToMakeTemplate = function (organizationId, appId, version) { return __awaiter(void 0, void 0, void 0, function () {
        var latestMinorVersion;
        return __generator(this, function (_a) {
            resetTemplate();
            latestMinorVersion = props.platformVersion.minor;
            if (latestMinorVersion - version > 2) {
                setUpdateModalOpen(true);
            }
            else {
                navigate("/organizations/".concat(organizationId || 'shared', "/apps/").concat(appId, "/template"));
            }
            return [2 /*return*/];
        });
    }); };
    var handleAppVersionUpdate = function () {
        if (!appData.id)
            return;
        dispatch(appUpdateVersion(appData.id));
        setUpdateModalOpen(false);
    };
    var favouritesMaxLimitExceeded = (props.apps || []).filter(function (app) { return app.is_favourite; }).length >= 6;
    return (_jsxs(_Fragment, { children: [openTemplate && (_jsx(TemplateModal, { root: props.root || [], open: openTemplate, handleClose: handleClose, template: template, handleTemplateCreation: handleTemplateCreation, openCategoryCreationModal: handleOpenCategoryModal, appData: appData, categories: props.categories, organizations: orgs, deleteTemplate: props.deleteTemplate, templateLoading: props.templateLoading })), openCategory && (_jsx(CategoryModal, { open: openCategory, handleClose: handleCategoryModalClose, handleGoBack: handleCategoryModalGoBack, openEditModal: function (data) { return openEditModal(data); }, deleteCategory: handleCategoryDeletion, selectedOrganizationId: (_d = props.root) === null || _d === void 0 ? void 0 : _d.selectedOrganizationId })), openNewCategory && (_jsx(CategoryCreationModal, { open: openNewCategory, data: categoryData, handleClose: handleNewCategoryModalClose, handleGoBack: handleNewCategoryModalGoBack, handleCategoryCreation: handleCategoryCreation, selectedOrganizationId: (_e = props.root) === null || _e === void 0 ? void 0 : _e.selectedOrganizationId })), props.loadingTemplate ? (_jsx(ContentPadding, __assign({ fullCenter: true }, { children: _jsxs(SuccessContainer, { children: [_jsx(SuccessTextContainer, { children: _jsx(H3, { children: "Loading apps..." }) }), _jsx(FontAwesomeIcon, { color: "grey", size: "2x", icon: faSpinner, spin: true, style: { margin: 15 } })] }) }))) : props.selectedView === 1 ? (_jsx(AppGridContainer, { children: _jsx(Table, { grid: true, pageSize: 12, data: searchFn(props.searchValue, props.apps), columns: Columns, renderGridItem: function (app) {
                        var _a, _b, _c, _d;
                        return (_jsx(GridViewWidget, { title: app.name, icon: app.icon, orgName: app.org_name, orgId: app.org_id, template: app.template, resetTemplate: resetTemplate, clearMedia: clearMedia, date: app.updated_at, playStore: app.playstore, appStore: app.appstore, pwaWeb: app.pwa, totalUsers: app.user_count, onClickEdit: function () {
                                var _a;
                                var latestMinorVersion = props.platformVersion.minor;
                                var appMinorVersion = ((_a = app.platform_version) === null || _a === void 0 ? void 0 : _a.minor) || 0;
                                if (latestMinorVersion - appMinorVersion > 2) {
                                    setUpdateModalOpen(true);
                                }
                                else {
                                    navigate("/organizations/".concat(app.org_id || 'shared', "/apps/").concat(app.id, "/overview"));
                                }
                            }, goToOrg: function (org) { return dispatch(actions.goToOrg(org, navigate)); }, isUpdateAvailable: !isMajorMinorEqual(props.platformVersion, app.platform_version), currentMinorVersion: (_a = app.platform_version) === null || _a === void 0 ? void 0 : _a.minor, appId: app.id, navigate: navigate, showFavourite: props.orgId !== 'shared', is_favourite: app.is_favourite, onClickIsFavourite: function () { return __awaiter(void 0, void 0, void 0, function () {
                                var result;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, props.setIsFavourite(app.org_id, app.id, !app.is_favourite)];
                                        case 1:
                                            result = _a.sent();
                                            result
                                                ? app.is_favourite
                                                    ? toast.success('Removed from favourites successfully')
                                                    : toast.success('Added to favourites successfully')
                                                : favouritesMaxLimitExceeded
                                                    ? toast.error('You can choose only 6 apps')
                                                    : toast.error('Something went wrong when updating favourite');
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, appVersion: "".concat(((_b = app.platform_version) === null || _b === void 0 ? void 0 : _b.major) || 0, ".").concat(((_c = app.platform_version) === null || _c === void 0 ? void 0 : _c.minor) || 0, ".").concat(((_d = app.platform_version) === null || _d === void 0 ? void 0 : _d.patch) || 0) }));
                    } }) })) : (_jsx(Table, { columns: Columns, onRowClick: onRowClick, searchValue: props.searchValue, data: getRows(), pageSize: 10, pageIndex: props.paginationIndex, gotoPage: function (index) {
                    props.setPagination('apps', index);
                } })), updateModalOpen && (_jsx(UpdateAppModal, { updateModalOpen: updateModalOpen, setUpdateModalOpen: setUpdateModalOpen, handleAppVersionUpdate: handleAppVersionUpdate, loadingUpdate: false, forcedUpdate: true }))] }));
};
var mapStateToProps = createStructuredSelector({
    apps: makeSelectApps(),
    loadingTemplate: makeSelectLoadingApps(),
    meta: makeSelectAppsMeta(),
    root: makeSelectRoot(),
    paginationIndex: makeSelectPaginationIndex('apps')(),
    platformVersion: makeSelectPlatformVersion(),
    organizationsWithWritePerm: makeSelectOrganizationsWithWritePerm(),
    categories: makeSelectCategories(),
    template: makeSelectTemplate(),
    templateLoading: makeSelectTemplateLoading(),
    orgId: selectOrganizationId,
});
var mapDispatchToProps = function (dispatch) { return ({
    deleteApp: function (appId) {
        dispatch(actions.deleteApp(appId));
    },
    createAppTemplate: function (template) {
        return dispatch(actions.createAppTemplate(template));
    },
    updateAppTemplate: function (template, templateId) {
        return dispatch(actions.updateAppTemplate(template, templateId));
    },
    getTemplateData: function (templateId) { return dispatch(actions.getTemplateData(templateId)); },
    clearMedia: function (appId) { return dispatch(actions.clearMedia(appId)); },
    deleteTemplate: function (templateId) { return dispatch(actions.deleteTemplate(templateId)); },
    getCategories: function (orgId) { return dispatch(actions.getCategories(orgId)); },
    createCategory: function (orgId, category) {
        return dispatch(actions.createCategory(orgId, category));
    },
    updateCategory: function (orgId, category) {
        return dispatch(actions.updateCategory(orgId, category));
    },
    deleteCategory: function (orgId, categoryId) {
        return dispatch(actions.deleteCategory(orgId, categoryId));
    },
    selectOrganization: function (orgId, userId) {
        var currentOrganization = storageService.getItem('selectedOrganizationId');
        if (orgId !== currentOrganization) {
            dispatch(actions.selectOrganization(orgId, userId));
            dispatch(actions.loadApps());
        }
    },
    setPagination: function (paginationName, paginationIndex) {
        return dispatch(actions.setPagination(paginationName, paginationIndex));
    },
    loadOrganizationsWithWritePerm: function () {
        return dispatch(actions.listOrganizationswithAppWritePerm());
    },
    setIsFavourite: function (orgId, appId, is_favourite) {
        return dispatch(actions.updateFavourite(orgId, appId, is_favourite));
    },
    resetTemplate: function () { return dispatch(templateActions.resetTemplate()); },
}); };
var withConnect = connect(mapStateToProps, mapDispatchToProps);
// weird typescript compilation error only in aws codebuild
export default compose(withConnect)(AppList);
